export function GetToday(){
    return GetDateString(new Date());
}

export function GetNow(){
    return GetDateTimeString(new Date());
}

export function GetTommorow(){
    return GetDateString(new Date(Date.now()+1000*60*60*24));
}

export function GetNextDay(day:string){
    return GetDateString(new Date(Date.parse(day)+1000*60*60*24));
}

export function GetFutureDay(origin:string,amount:number){
    return GetDateString(new Date(Date.parse(origin)+1000*60*60*24*amount));
}

export function GetNextWeek(origin:string=GetDateString(new Date())){
    return GetDateString(new Date(Date.parse(origin)+1000*60*60*24*7));
}

export function GetNextMonth(origin:string=GetDateString(new Date())){
    return GetDateString(new Date(Date.parse(origin)+1000*60*60*24*30));
}

export function GetYesterday(){
    return GetDateString(new Date(Date.now()-1000*60*60*24));
}

export function GetLastDay(day:string){
    return GetDateString(new Date(Date.parse(day)-1000*60*60*24));
}
export function GetPastDay(origin:string,amount:number){
    return GetDateString(new Date(Date.parse(origin)-1000*60*60*24*amount));
}

export function GetLastWeek(origin:string=GetDateString(new Date())){
    return GetDateString(new Date(Date.parse(origin)-1000*60*60*24*7));
}
export function GetLastMonth(origin:string=GetDateString(new Date())){
    return GetDateString(new Date(Date.parse(origin)-1000*60*60*24*30));
}

export function GetDateString(Date:Date){
    let year=Date.getFullYear();
    let Month=Date.getMonth();
    let Day=Date.getDate();

    let str=year+"-";
    if(Month<9){
        str+="0"
    }
    str+=(Month+1)+"-";
    if(Day<10){
        str+="0"
    }
    str+=Day;
    return str;
}

export function GetDateTimeString(Date:Date){
    let year=Date.getFullYear();
    let Month=Date.getMonth();
    let Day=Date.getDate();
    let hour=Date.getHours();
    let minite=Date.getMinutes();
    let second=Date.getSeconds();

    let str=year+"-";
    if(Month<9){
        str+="0"
    }
    str+=(Month+1)+"-";
    if(Day<10){
        str+="0"
    }
    str+=Day+"T";
    if(hour<10){
        str+="0"
    }
    str+=hour+":"
    if(minite<10){
        str+="0"
    }
    str+=minite+":";
    if(second<10){
        str+="0"
    }
    str+=second;
    return str;
}